<template>
  <div class="wrapper">
    <ul class="current_user">
      <li>姓名：{{ selectdata.patientname }}</li>
      <li>就诊ID号：<span>{{ selectdata.patientId }}</span></li>
      <!-- <li>身份证：<span>{{ selectdata.idcardno.replace(/(\w{4})\w*(\w{4})/, "$1******$2") }}</span></li> -->
      <!-- 事件：打开就诊人切换弹窗 -->
      <span @click="showNation = true" class="switch">切换就诊人</span>
      <!-- 事件：查看电子健康卡 -->
      <img src="@/assets/record/jkm2.png" @click.stop="cardbtn(selectdata)" />
    </ul>
    <!-- 事件：打开时间区间筛选弹窗 -->
    <div class="list_time" @click="openTime">
      <span>查询时间</span>
      <span class="time_icon">
        {{ zsStartTime }} 至 {{ zsEndtTime }}
        <van-icon name="arrow" />
      </span>
    </div>
    <!-- 事件：tab 切换时重新查询报告 -->
    <van-tabs style="margin: 0px 4px;" v-model="active" title-active-color="#3C9ECF" swipeable @click="reportQuery">
      <van-tab title="检验报告">
        <ul v-if="jyList.length" class="jy_list">
          <!-- 事件：进入检验报告详情 -->
          <li v-for="item in jyList" :key="item.labNo" @click="go(1, item)">
            <div class="jy_left">
              <van-icon name="newspaper-o" />
            </div>
            <div class="jy_right">
              <span class="name">{{ item.checkTypeName }}</span>
              <span class="kstime">
                <span>{{ item.applyDept }}</span>
                <span>{{ item.checkTime }}</span>
              </span>
            </div>
          </li>
        </ul>
        <van-empty v-else
          class="custom-image"
          image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
          description="暂无报告"
        />
      </van-tab>
      <van-tab title="检查报告">
        <ul v-if="jcList.length" class="jy_list">
          <!-- 事件：进入检查报告详情 -->
          <li v-for="item in jcList" :key="item.labNo" @click="go(2, item)">
            <div class="jy_left">
              <van-icon name="newspaper-o" />
            </div>
            <div class="jy_right">
              <span class="name">{{ item.checkTypeName }}</span>
              <span class="kstime">
                <span>{{ item.applyDept }}</span>
                <span>{{ item.checkTime }}</span>
              </span>
            </div>
          </li>
        </ul>
        <van-empty v-else
          class="custom-image"
          image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
          description="暂无报告"
        />
      </van-tab>
    </van-tabs>
    <van-popup v-model="showNation" round position="bottom">
      <!-- 事件：confirm 切换就诊人；cancel 关闭弹窗 -->
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirmNation"
        @cancel="showNation = false"
      />
    </van-popup>
    <van-popup class="lttc" v-model="showTime" round position="top">
      <div style="color: #666;font-size: 14px;">查询时间</div>
      <div class="time_sel">
        <!-- 事件：打开开始日期选择日历 -->
        <input class="input_class" type="text" v-model="startTime" @click="showSart = true" />
        <span class="xg">/</span>
        <!-- 事件：打开结束日期选择日历 -->
        <input class="input_class" type="text" v-model="endtTime" @click="showEnd = true" />
      </div>
      <div class="btns">
        <!-- 事件：关闭时间筛选弹窗（不生效） -->
        <van-button @click="showTime = false" type="default">取消</van-button>
        <!-- 事件：确认时间筛选并重新查询 -->
        <van-button @click="qdbtn" type="info">确定</van-button>
      </div>
    </van-popup>
    <!-- 事件：确认选择开始日期 -->
    <van-calendar
      :default-date="defaultDate"
      v-model="showSart"
      @confirm="onConfirmStart"
      color="#1989fa"
      :min-date="minDate"
      :max-date="maxDate"
    />
    <!-- 事件：确认选择结束日期 -->
    <van-calendar
      v-model="showEnd"
      @confirm="onConfirmEnd"
      color="#1989fa"
      :min-date="minDate"
      :max-date="maxDate"
    />
    <judgment></judgment>
  </div>
</template>

<script>
import { selectVisitinfos, getCkLabResult } from "@/request/api.js";
import Judgment from "@/components/Judgment/Judgment.vue";

const USER_ID = "7148";

function apiObj(res) {
  return ((res || {}).data || {}).obj || {};
}
export default {
  components: {
    Judgment
  },
  data() {
    return {
      showNation: false,
      showTime: false,
      showSart: false,
      showEnd: false,
      columns: [],
      selectdata: {
        idcardno: ""
      },
      active: 0,
      minDate: "",
      maxDate: "",
      defaultDate: "",
      startTime: "",
      endtTime: "",
      zsStartTime: "",
      zsEndtTime: "",
      jyList: [],
      jcList: []
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 从首页进入时重新拉一次就诊人（避免缓存旧数据）
      if(from.path == "/" || from.path == "/index"){
        vm.getVisitinfos();
      }
    })
  },
  created() {
    // 初始化默认时间区间（近一月）
    this.getDate();
  },
  methods: {
    /** 初始化查询时间区间：默认近 1 个月；限制可选范围为近 1 年 */
    getDate(){
      const now = this.$moment();
      this.minDate = new Date(now.clone().subtract(1, "year").format("YYYY-MM-DD"));
      this.maxDate = new Date(now.format("YYYY-MM-DD"));
      this.defaultDate = new Date(now.clone().subtract(1, "months").format("YYYY-MM-DD"));
      this.startTime = this.$moment(this.defaultDate).format("YYYY-MM-DD");
      this.endtTime = this.$moment(this.maxDate).format("YYYY-MM-DD");
      this.zsStartTime = this.startTime;
      this.zsEndtTime = this.endtTime;
    },
    /** 获取当前 openid 下所有就诊人，并默认选中 style=1 或第一个 */
    async getVisitinfos() {
      try {
        const openid = sessionStorage.getItem("openid");
        const res = await selectVisitinfos({ openid });
        const list = apiObj(res) || [];
        this.columns = list;
        list.forEach(item => {
          item.text = item.patientname;
          if (item.style == 1) {
            this.selectdata = item;
          }
        });
        if (!this.selectdata.patientId && list.length) this.selectdata = list[0];
        this.reportQuery();
      } catch (e) {
        this.columns = [];
        this.selectdata = { idcardno: "" };
        this.jyList = [];
        this.jcList = [];
      }
    },
    /** 事件：切换就诊人（picker confirm） */
    onConfirmNation(value) {
      this.selectdata = value;
      this.showNation = false;
      this.reportQuery();
      this.Toast("切换成功");
    },
    /** 查询报告列表：active=0 检验(type=1)，active=1 检查(type=2) */
    async reportQuery(){
      if (!this.selectdata.patientId) return;
      const type = this.active === 0 ? 1 : 2;
      const map = {
        patientID: this.selectdata.patientId,
        startDate: this.zsStartTime,
        stopDate: this.zsEndtTime,
        type,
        userId: USER_ID
      };
      try {
        const res = await getCkLabResult(map);
        const ok = res.data && res.data.message === "操作成功";
        const list = ok ? (apiObj(res).resultData || []) : [];
        if (type === 1) this.jyList = list;
        else this.jcList = list;
      } catch (e) {
        if (type === 1) this.jyList = [];
        else this.jcList = [];
      }
    },
    /** 事件：查看电子卡 */
    cardbtn(item) {
      sessionStorage.setItem("card", JSON.stringify(item));
      this.$router.push("/HealthCard");
    },
    /** 事件：打开查询时间弹窗 */
    openTime(){
      this.showTime = true;
      this.startTime = this.zsStartTime;
      this.endtTime = this.zsEndtTime;
    },
    /** 事件：确认查询时间区间 */
    qdbtn(){
      this.showTime = false;
      this.zsStartTime = this.startTime;
      this.zsEndtTime = this.endtTime;
      this.reportQuery();
    },
    /** 事件：进入报告详情 */
    go(num, item){
      sessionStorage.setItem("report",JSON.stringify(item));
      this.$router.push(num === 1 ? "/textReportetails" : "/screenReportetails");
    },
    /** 事件：选择开始日期 */
    onConfirmStart(data) {
      this.startTime = this.$moment(data).format("YYYY-MM-DD");
      this.showSart = false;
    },
    /** 事件：选择结束日期 */
    onConfirmEnd(data) {
      this.endtTime = this.$moment(data).format("YYYY-MM-DD");
      this.showEnd = false;
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f8f8f8;
  /deep/ .van-tabs {
    border-top: 1px solid #f9f9f9;
    border-bottom: 1px solid #f9f9f9;
    .van-tab__text--ellipsis {
      letter-spacing: 1px;
      font-size: 16px;
      font-weight: 600;
    }
    .van-tabs__line {
      background-color: #3c9ecf !important;
    }
  }
  .current_user {
    position: relative;
    margin: 4px 4px 2px 4px;
    padding: 10px;
    background: #e6f5fc;
    border-radius: 6px;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 1px;
    > li {
      > span {
        letter-spacing: 0px;
      }
    }
    > li:nth-child(2) {
      margin: 10px 0px;
    }
    .switch{
      position: absolute;
      top: 10px;
      right: 20px;
      color: #6098ff;
    }
    >img{
      position: absolute;
      width: 40px;
      right: 46px;
      bottom: 10px;
    }
  }
  /deep/ .list_time {
    position: relative;
    margin: 4px 4px 2px 4px;
    padding: 10px;
    background: #e6f5fc;
    border-radius: 6px;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    .time_icon {
      position: relative;
      display: flex;
      align-items: center;
      .van-icon {
        margin-left: 4px;
        position: relative;
        top: 1px;
        font-weight: bold;
      }
    }
  }
  /deep/ .lttc {
    padding-top: 10px;
    > div {
      padding: 0px 10px;
    }
    .time_sel {
      // text-align: center;
      position: relative;
      margin: 10px 0px;
      .input_class {
        text-align: center;
        caret-color: transparent;
        border: 1px solid #666;
        width: 140px;
        height: 30px;
      }
      .xg {
        position: relative;
        top: 4px;
        color: #666;
        margin: 0px 10px;
        font-size: 22px;
      }
    }
    .btns {
      padding: 0px;
      border: 1px solid #999;
      height: 40px;
      display: flex;
      button {
        font-size: 14px;
        letter-spacing: 10px;
        flex: 1;
      }
    }
  }
  /deep/ .jy_list {
    display: flex;
    flex-flow: column nowrap;
    padding: 0px 16px;
    background: #fff;
    > li {
      padding: 16px 0px;
      border-bottom: 1px solid #ddd;
      display: flex;
      flex-flow: row nowrap;
      font-size: 16px;
      align-items: center;
      .jy_left{
        width: 16%;
        .van-icon{
          background: #FFD700;
          border-radius: 50%;
          color: white;
          width: 46px;
          height: 46px;
          line-height: 46px;
          text-align: center;
          font-size: 30px;
        }
      }
      .jy_right{
        // flex: 1;
        width: 84%;
        display: flex;
        flex-flow: column nowrap;
        .name {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          -o-text-overflow:ellipsis;
        }
        .kstime {
          display: flex;
          flex-flow: row nowrap;
          justify-content: space-between;
          font-size: 12px;
          margin-top: 10px;
          color: #666;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/Report/report.vue